module.exports = __webpack_public_path__ + "img/banner3@2x.ebc7d3f8.png";